import React from 'react'

import { Box } from 'widgets/Box'
import { BorderButton } from 'widgets/Button/BorderButton'
import { FilledButton } from 'widgets/Button/FilledButton'
import { Text } from 'widgets/Text'

import { useMaxWidth } from 'hooks/useMaxWidth'

import { SpacingTypes } from 'utils/themes/types'

type ButtonMeta = {
  title: string
  type?: 'primary' | 'secondary'
  onPress?: () => void
}

type EmptyStateProps = {
  title: string
  subtitle: string
  subtitle2?: string
  inBetweenMargin?: SpacingTypes
  actionButtons?: ButtonMeta[]
}

export const EmptyState = ({
  title,
  subtitle,
  subtitle2,
  inBetweenMargin,
  actionButtons,
}: EmptyStateProps) => {
  const { width: maxWidth } = useMaxWidth()

  return (
    <Box flex={1} align='center' justifyContent='center'>
      <Box margin={{ bottom: inBetweenMargin ?? 'lg' }} maxWidth={300}>
        <Text bold color='black' align='center'>
          {title}
        </Text>
        <Text color='greyDark' align='center' fontSize='sm'>
          {subtitle}
        </Text>
        {subtitle2 && (
          <Box margin={{ top: 'smd' }}>
            <Text color='greyDark' align='center' fontSize='sm'>
              {subtitle2}
            </Text>
          </Box>
        )}
      </Box>
      <Box margin={{ top: inBetweenMargin ?? 'lg' }}>
        {actionButtons?.map((button) => {
          const { title: text, type = 'primary', onPress } = button

          return (
            <Box margin={{ bottom: 'sm' }} key={`empty-state-action-button-${text}`}>
              {type === 'primary' ? (
                <FilledButton
                  title={text}
                  width={maxWidth * 0.8}
                  height={50}
                  borderRadius='smd'
                  onPress={onPress}
                />
              ) : (
                <BorderButton
                  title={text}
                  width={maxWidth * 0.8}
                  height={50}
                  borderRadius='smd'
                  titleColor='v2primary'
                  border={{ color: 'v2primary', width: 2 }}
                  onPress={onPress}
                />
              )}
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}
